import { Box, Card } from "@mui/material"
import { Tabs } from "lib/@components/tabs"

export const LEGISLATION_DETAIL_RIGHT_BAR_ID = "LegislationDetailRightBar"

export function LegislationDetailSidebar() {
    return (
        <Card
            sx={{
                mx: 0,
                my: 0,
                width: 1,
                display: "flex",
                flexDirection: "column",
            }}
            data-cy="legislation-detail-sidebar"
        >
            <Tabs
                id={LEGISLATION_DETAIL_RIGHT_BAR_ID}
                tabHolder={<Box sx={{ px: 2, bgcolor: "background.neutral" }} />}
                panelHolder={<Box sx={{ mt: 1, flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }} />}
            />
        </Card>
    )
}
